<svg
  [ngClass]="{
    'mr-[24px] xlplus:mr-[32px] mt-[24px] xlplus:mt-[32px]': !isMobile(),
    'mr-3': isMobile()
  }"
  class="cursor-pointer xlplus:w-[24px] xlplus:h-[24px] w-[22px] h-[22px]"
  (click)="redirectToProfilePage()"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
    stroke="black"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
    stroke="black"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
<svg
  [ngClass]="{
    'mt-[24px] xlplus:mt-[32px]': !isMobile()
  }"
  class="cursor-pointer xlplus:w-[24px] xlplus:h-[24px] w-[22px] h-[22px]"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  (click)="confirmLogout()"
>
  <path
    d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9"
    stroke="black"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M16 17L21 12L16 7"
    stroke="black"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M21 12H9"
    stroke="black"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
<p-confirmDialog 
[closable]="false" 
[dismissableMask]="true"
[style]="{ width: '450vw', maxWidth: '450px', margin: '25px' }"
[baseZIndex]="10000"
>
  <ng-template
    pTemplate="headless"
    let-message
    let-onAccept="onAccept"
    let-onReject="onReject"
  >
    <div class="bg-white rounded-2xl w-full max-w-[450px] max-h-[223vh] overflow-y-auto p-[28px] xlplus:p-[28px]">
      <div class="flex items-center gap-3">
        <h3 class="font-inter font-semibold text-[24px] xlplus:text-2xl">Log Out</h3>
      </div>

      <div class="font-lato font-normal text-taxpod-gray text-[16px] xlplus:text-base mt-[16px]">
        <p>Are you sure you want to log out? Any unsaved progress will be lost.</p>
      </div>

      <div class="flex gap-4 justify-end mt-[18px]">
        <p-button
          label="Cancel"
          (onClick)="onReject()"
          variant="outlined"
          styleClass="!w-[100px] xlplus:!w-[100px] !border-taxpod-blue !text-taxpod-blue !border-[1.5px] !text-sm xlplus:!text-base hover:!bg-[#E0F2FE]"
        />

        <p-button
          label="Logout"
          (onClick)="logout()"
          styleClass="!w-[100px] xlplus:!w-[100px] !bg-taxpod-blue !border-taxpod-blue !border-[1.5px] !text-sm xlplus:!text-base !font-lato !font-bold"
        />

      </div>
    </div>
  </ng-template>
</p-confirmDialog>